import React, { Dispatch } from 'react';

import { Box } from '@waglabs/box-next';
import { Button } from '@waglabs/button-next';
import { Modal } from '@waglabs/seo-modals';
import { Typography } from '@waglabs/typography';

import { DATA_TEST_IDS } from '../../constants';
import { WagKeyIllustrationIcon } from '../../icons';

export type LinkAccountsModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<React.SetStateAction<boolean>>;
  handleNext: (...args: Array<any>) => any;
}

export const LinkAccountsModal = ({
  setIsModalOpen,
  isModalOpen,
  handleNext,
}: LinkAccountsModalProps) => {
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleLinkingAccounts = () => {
    handleNext();
  };
  return (
    <Modal
      backgroundColor="#EDEDED"
      isOpen={isModalOpen}
      onRequestClose={toggleModal}
    >
      <Box
        data-testId={DATA_TEST_IDS.Components.LinkAccountsModal.LinkAccountsModal}
        display="grid"
        backgroundColor="#EDEDED"
        alignItems="center"
        justifyItems="center"
      >
        <WagKeyIllustrationIcon
          marginTop="20px"
          width="200px"
          height="150px"
        />
        <Typography
          textAlign="center"
          fontSize={['30px', '38px']}
          lineHeight="37px"
          fontFamily="Muli SemiBold"
        >
          Already have a Wag! account?
        </Typography>
        <Typography
          textAlign="center"
          fontSize={['20px', '22px']}
          lineHeight="25px"
        >
          There's already a Wag! account with your email.
        </Typography>
        <Box
          width="100%"
          gridTemplateColumns={['4.7fr 90.6fr 4.7fr', '8fr 84fr 8fr']}
          display="grid"
        >
          <Button
            gridColumn="2/span 1"
            variant="contained"
            height="56px"
            fontFamily={['Muli SemiBold', 'Muli Bold']}
            marginBottom="8px"
            onClick={handleLinkingAccounts}
          >
            Sign in to link accounts
          </Button>
          <Button
            height="56px"
            fontFamily={['Muli SemiBold', 'Muli Bold']}
            gridColumn="2/span 1"
            variant="outlined"
            marginBottom="16px"
            onClick={toggleModal}
          >
            Choose another way to sign in
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
